import { denormalize } from "normalizr";

import { receivable } from "../../../api/schema";

export default id => state => {
  try {
    const denormalized = denormalize(
      { item: id },
      { item: receivable },
      state.entities
    );
    return denormalized.item || {};
  } catch (err) {
    return {};
  }
};
